export const removeSubsequentSpaces = (value: string): string => {
  const newValue = value || '';

  return newValue.replace(/\s{2,}/g, ' ');
};
